import classes from "./Page.module.scss";
import { PropsWithChildren } from "react";
import { BackButton } from "components/buttons";
import { useNavigate } from "react-router-dom";
import { className } from "utils/strings";

type IProps = PropsWithChildren<{
  title: string;
}>;

export const Page = (props: IProps) => {
  const { title, children } = props;

  const navigate = useNavigate();

  return (
    <div className={className({
      [classes.page]: true,
      "narrow": true,
      "page": true,
    })}>
      <div className={classes.title}>
        <BackButton
          onClick={() => {
            navigate(-1);
          }}
        />
        <h3>{title}</h3>
      </div>

      <div className={classes.content}>
        {children}
      </div>
    </div>
  );
};
